import { AppThunk, AppDispatch } from '@app/store/store'
import { v4 as uuidv4 } from 'uuid'

import { Notification, NotificationActionType } from './types'
import { actions } from './slice'

export const addNotification = (notification: Omit<Notification, 'id'>): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(
    actions.addNotification({
      ...notification,
      actionType: notification.actionType || NotificationActionType.Close,
      id: uuidv4()
    })
  )
}

export const removeNotification = (notificationId: Notification['id']): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.removeNotification(notificationId))
}
